<!--
 * @Author: FengXiao
 * @Date: 2020-07-14 11:09:36
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-19 14:42:36
-->
<template>
  <div class="video-player-base">
    <div class="video-bg">
      <img class="video-bg-img" :src="video.cover" />
      <div class="video-bg-shadow"></div>
    </div>
    <div class="video-player-content content">
      <div class="vip_lockinfo" v-show="viplock">
        <img :src="video.cover">
        <div class="viplock_div">
          <div class="viplock_icon_btn">
            <div class="viplock_icon">
              <img src="../../src/assets/imgs/vip_lock.png">
            </div>
            <div class="viplock_btn" @click="joinVip()">加入会员</div>
          </div>
        </div>
      </div>
      <div class="video-player-bl" v-show="!viplock">
        <div class="video-wrap">
          <video ref="video" id="video-player" class="video-player video-js vjs-big-play-centered" controls
            preload="auto"></video>
          <div class="clarity_menu vjs-menu clarity_menu-flag" v-show="showClarityMenu">
            <ul class="vjs-menu-content clarity_menu-flag" role="menu">
              <li class="vjs-menu-item clarity_menu-flag" :class="{ 'vjs-selected': activatedClarityType === 3 }"
                v-if="chaoqingshow" tabindex="-1" role="menuitemcheckbox" type="4" @click="changeVideo(3)">
                1080P超清(会员)
              </li>
              <li class="vjs-menu-item clarity_menu-flag" :class="{ 'vjs-selected': activatedClarityType === 2 }"
                tabindex="-1" role="menuitemcheckbox" type="3" @click="changeVideo(2)">
                高清
              </li>
              <li class="vjs-menu-item clarity_menu-flag" :class="{ 'vjs-selected': activatedClarityType === 1 }"
                tabindex="-1" role="menuitemcheckbox" type="2" @click="changeVideo(1)">
                标清
              </li>

            </ul>
          </div>
          <transition name="el-fade-in-linear">
            <div class="volume_toast" v-show="volumeToast">
              <i class="iconfont iconvolume"></i>
              <span class="volume_value">{{ volumeToastValue }}<span class="volume_value-unit">%</span> </span>
            </div>
          </transition>
          <div class="ended-tips-wrap" v-if="showEndTips">
            <p class="title">本集播放结束</p>
            <div v-if="readyCountdown">
              <div class="ready-countdown">{{ readyCountdown }}</div>
              <div class="subtitle">正在准备播放下一集</div>
            </div>
            <div class="actions-bl">
              <div class="jump_btn btn" @click="jumpReady">
                跳过
              </div>
              <div class="cancel_btn btn" @click="cancelAutoPlay">
                取消
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot name="right-area">
        <div class="right-area">
          <!-- 新样式 -->
          <div class="speaker-info-bl">
            <div class="speaker-info-wrap">
              <div class="speaker-info">
                <div class="speaker_avatar">
                  <img class="speaker_avatar-img" :src="speaker.avatar" alt />
                </div>
                <div class="speaker_name">{{ speaker.name }}</div>
                <div class="speaker_intro">{{ speaker.intro }}</div>
                <div class="speaker_rank">
                  <span v-if="speaker.rank !== 0">一席第{{ speaker.rank }}位演讲者</span>
                  <span v-else>一席讲者</span>
                </div>
              </div>
              <div class="actions-bl">
                <div class="collectio_btn" @click.stop="collectFn" :class="{ active: isCollection }">
                  <img class="collectio_btn-icon" :src="heartIcon" />
                  <span>{{ isCollection ? '已收藏' : '收藏' }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 老样式 -->
          <!-- <div class="speaker-info-bl">
            <div class="speaker-info">
              <div class="speaker_avatar">
                <img class="speaker_avatar-img" :src="selfSpeaker.avatar" alt />
              </div>
              <div class="speaker_name">{{ selfSpeaker.name }}</div>
              <div class="speaker_intro">{{ selfSpeaker.intro }}</div>
              <div class="speaker_rank">一席第{{ selfSpeaker.rank }}位演讲者</div>
            </div>
          </div> -->
          <div class="video_intro" v-if="video.intro">{{ video.intro }}</div>
          <slot name="right-bottom-area"></slot>
        </div>
      </slot>
    </div>
    <buyvipDialog :payPopup="payPopup" v-show="payPopup" @close="close"></buyvipDialog>
  </div>
</template>

<script>
import 'video.js/dist/video-js.min.css';
import videojs from 'video.js';
import requestApi from '@/service';
import { mapState } from 'vuex';
import Cookies from 'js-cookie';
import buyvipDialog from '@/components/buy_vipDialog.vue';

const VOL = 0.1;
const TIME = 10;
const PLAYER_KEYS = [32, 37, 38, 39, 40];
const DEFAULT_COUNTDOWN_NUMBER = 5;
export default {
  props: {
    datas: {
      type: [Object, Array],
      default: () => ({}),
    },
    speaker: {
      type: Object,
      default: () => ({}),
    },
    allowEvent: {
      type: Boolean,
    },
    viplock: {
      type: Boolean,
      default: false,
    },
    collect: {
      type: Boolean,
      default: false,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    index: {
      type: [String, Number],
      default: 0,
    },
  },
  model: {
    props: 'allowEvent',
  },
  components: {
    buyvipDialog,
  },
  data() {
    return {
      payPopup: false,
      chaoqingshow: false,
      video: {},
      selfSpeaker: {},
      showClarityMenu: false, // 清晰度列表
      activatedClarityType: 2,
      volumeToast: false,
      volumeToastValue: '0',
      allowPlayerEvents: this.allowEvent,
      isCollection: this.collect, // 是否收藏
      showEndTips: false, // 结束画面
      readyCountdown: 0, // 准备倒计时
      is_first: true,
      video_type: '',
      video_id: '',
    };
  },
  computed: {
    ...mapState(['vipInfo']),
    heartIcon() {
      return require(`@/assets/imgs/icon/${this.isCollection ? 'heart-light' : 'heart'}.png`);
    },
    // 检查videoUrls是否有效
    hasValidVideoUrls() {
      if (!this.video || !this.video.videoUrls) {
        return false;
      }
      if (Array.isArray(this.video.videoUrls)) {
        return this.video.videoUrls.length > 0 && this.video.videoUrls.some(url => url.video_url);
      }
      return !!this.video.videoUrls;
    }
  },
  mounted() {
    this.addEvents();
    this.initPlayer();
  },
  beforeDestroy() {
    clearTimeout(this.playerKeyEventTimer);
    clearTimeout(this.showVolumeToastTimer);
    this.removeEvents();
    this.addEvents();
    this.player && this.player.dispose();
  },
  watch: {
    datas: {
      handler(data) {
        if (Array.isArray(data)) {
          if (data.length) {
            this.video = data[0];
            this.chapterIndex = 0;
          }
        } else {
          this.video = data;
        }
        this.updateVideo();
        // 当数据更新时，也要更新播放器控件
        this.updatePlayerControls();
      },
      deep: true,
    },
    videowitch(val) {
      console.log(val)
    },
    speaker(data) {
      this.selfSpeaker = data;
    },
    allowEvent(val) {
      this.allowPlayerEvents = val;
    },
    allowPlayerEvents(val) {
      this.$emit('update:allowEvent', val);
    },
    collect(val) {
      this.isCollection = val;
    },
    index(val) {
      if (Array.isArray(this.datas) && this.chapterIndex != val) {
        this.chapterIndex = val;
        this.setChapter();
      }
    },
  },
  methods: {
    close(val) {
      this.payPopup = false
    },
    // 防抖函数
    _debounce(func, key, delay) {
      // 清除定时器，如果有的话
      if (this[`Debounce-${key}`]) {
        clearTimeout(this[`Debounce-${key}`]);
      }

      // 设置新的定时器
      this[`Debounce-${key}`] = setTimeout(() => {
        func.call(this);
        this[`Debounce-${key}`] = null;
      }, delay);
    },
    //截取参数
    geturl() {
      var url = window.location.href
      var videoId = url.split("?")[1]
      this.video_id = videoId.split("&")[0].split("=")[1] - 0
      //演讲
      if (url.indexOf("speech") > 1) {
        this.video_type = 0
      }
      //枝桠
      if (url.indexOf("zhiya") > 1) {
        this.video_type = 2
        this.video_id = videoId.split("&")[1].split("=")[1] - 0
      }
      //记录
      if (url.indexOf("record") > 1) {
        this.video_type = 4
      }
      //万象
      if (url.indexOf("wanxiang") > 1) {
        this.video_type = 7
      }
      // console.log(this.video_type)
    },
    //增加播放量
    addplaer() {
      this.geturl()
      requestApi('/v3/api/h5/play_count/', {
        video_type: this.video_type,
        video_id: this.video_id
      }, 'post')
    },
    initPlayer() {
      this.player = videojs(this.$refs.video, {
        language: 'zh-CN',
        controls: true,
        controlBar: {
          children: [
            { name: 'playToggle' }, // 播放按钮
            { name: 'currentTimeDisplay' }, // 当前已播放时间
            { name: 'progressControl' }, // 播放进度条
            { name: 'durationDisplay' }, // 总时间
            {
              name: 'volumePanel', // 音量控制
              inline: false, // 不使用水平方式
            },
            // 倍数播放
            {
              name: 'playbackRateMenuButton',
              playbackRates: [0.5, 1, 1.25, 1.5, 2],
            },
            {
              name: 'clarityMenu', // 高清切换
            },
            { name: 'FullscreenToggle' }, // 全屏
          ],
        },
      });

      // 根据videoUrls有效性初始设置控件可见性
      this.$nextTick(() => {
        this.updatePlayerControls();
      });

      this.createBtns();
      this.registerPlayerEvents();
    },
    registerPlayerEvents() {
      // 开始播放时 播放器键盘事件允许执行
      this.player.on('play', () => {
        if (this.is_first) {
          this.addplaer()
          this.is_first = false
        }
        if (!this.allowPlayerEvents) {
          this.allowPlayerEvents = true;
        }
      });
      // 播放结束
      this.player.on('ended', () => {
        if (this.autoPlay && Array.isArray(this.datas)) {
          this.readyPlayNext();
        }
      });
    },
    addEvents() {
      // if(this.viplock) return
      document.body.addEventListener('click', this.hideClarityMenu);
      document.body.addEventListener('keydown', e => {
        if (this.allowPlayerEvents && PLAYER_KEYS.includes(e.keyCode)) {
          event.preventDefault();
          if (this.playerKeyEventTimer) return;
          this.playerKeyEventTimer = setTimeout(() => {
            this.playerKeyEventTimer = null;
          }, 800);
          // eslint-disable-next-line no-undef
          let curTime = this.player.currentTime();
          let volume = this.player.volume();
          switch (e.keyCode) {
            case 38: // up
              volume !== 1 ? this.player.volume((volume += VOL)) : this.player.volume(1);
              this.showVolumeToast();
              break;
            case 40: // down
              volume !== 0 ? this.player.volume((volume -= VOL)) : this.player.volume(0);
              this.showVolumeToast();
              break;
            case 37: // left
              curTime !== 0 ? this.player.currentTime((curTime -= TIME)) : this.player.currentTime(0);
              break;
            case 39:
              curTime !== this.player.duration() ? this.player.currentTime((curTime += TIME)) : this.player.currentTime(this.player.duration());
              break;
            case 32:
              console.log(1)
              if (this.player.paused()) {
                this.play();
              } else {
                this.pause();
              }
              break;
            default:
              break;
          }
        }
      });
      document.body.addEventListener('keyup', e => {
        if (this.allowPlayerEvents && PLAYER_KEYS.includes(e.keyCode)) {
          if (this.playerKeyEventTimer) {
            this.playerKeyEventTimer = null;
            clearTimeout(this.playerKeyEventTimer);
          }
        }
      });
    },
    removeEvents() {
      document.body.removeEventListener('click', this.hideClarityMenu);
    },
    showVolumeToast() {
      if (this.showVolumeToastTimer) {
        clearTimeout(this.showVolumeToastTimer);
      }
      this.showVolumeToastTimer = setTimeout(() => {
        this.volumeToast = false;
        this.showVolumeToastTimer = null;
      }, 1500);
      this.volumeToast = true;
      this.volumeToastValue = `${parseInt(this.player.volume() * 100)}`;
    },
    /**
       * @description: 添加自定义按钮 清晰度
       */
    createBtns() {
      let Button = videojs.getComponent('Button');
      const self = this;
      // 写的不够优雅 希望未来能够优化
      let clarityBtn = videojs.extend(Button, {
        constructor: function () {
          Button.apply(this, arguments);
          // this.controlText('高清');
          this.el_.innerHTML = '高清';
          // self.clarityBtnInner = this.el_.innerHTML;
        },
        handleClick: () => {
          if (this.video && this.video.videoUrls && this.video.videoUrls.length > 0) {
            this.video.videoUrls.forEach(item => {
              if (item.type == 3 || this.video_type == 7) {
                this.chaoqingshow = true
              }
            })
          }
          this.showClarityMenu = !this.showClarityMenu;
        },
        buildCSSClass: function () {
          return 'vjs-control vjs-button clarity_menu-flag';
        },
      });

      //注册
      videojs.registerComponent('clarityBtn', clarityBtn);
      this.$nextTick(() => {
        // 添加到controlBar中，只有在播放器存在且controlBar存在时才执行
        if (this.player && this.player.controlBar) {
          const controlBar = this.player.getChild('controlBar');
          if (controlBar && controlBar.children_) {
            const index = controlBar.children_.length - 1;
            controlBar.addChild('clarityBtn', {}, index);
          }
        }
      });
    },
    // changeVideo(type = this.activatedClarityType) {
    changeVideo(type) {
      const BtnInner = document.getElementsByClassName("clarity_menu-flag")
      if (this.activatedClarityType === type && this.showClarityMenu) {
        this.showClarityMenu = false;
      } else {
        const urlObj = this.video.videoUrls.filter(item => +item.type === +type)[0];
        if (this.vipInfo.status !== 1 && type == 3) {
          if (this.checkLogin()) {
            if (this.video_type == 7 && urlObj.video_url) {
              this.videoCurtiem(type, BtnInner)
            } else {
              this.pause();
              this.payPopup = true
            }
          }
        } else {
          this.videoCurtiem(type, BtnInner)
        }

      }
    },
    joinVip() {
      if (this.checkLogin()) {
        return this.payPopup = true
      }
    },
    videoCurtiem(type, BtnInner) {
      //视频打点
      const curTime = this.player.currentTime();
      const urlObj = this.video.videoUrls.filter(item => +item.type === +type)[0];
      if (urlObj && urlObj.video_url) {
        this.activatedClarityType = type;
        this.player.src(urlObj.video_url);
        this.player.load(urlObj.video_url);
        if (curTime) {
          setTimeout(() => {
            this.player.currentTime(curTime);
            this.play();
          }, 200);
        }
        BtnInner[0].innerHTML = urlObj.type_name
        this.$message.success(`已切换为${urlObj.type_name}`);
        if (this.clarityBtnInner) {
          this.clarityBtnInner = urlObj.type_name;
        }
        this.showClarityMenu = false;
      }
    },
    updateVideo() {
      if (!Object.keys(this.video).length || !this.player) return;
      // 截流
      this._debounce(
        () => {
          // 只有在播放器存在的情况下才重置
          if (this.player) {
            this.player.reset();
            this.player.poster(this.video.cover);
            if (this.video.videoUrls && this.video.videoUrls.length) {
              // 此处我们默认取高清
              let filterRes = this.video.videoUrls.filter(item => +item.type === 2);
              const BtnInner = document.getElementsByClassName("clarity_menu-flag");
              const urlObj = filterRes && filterRes[0] ? filterRes[0] : this.video.videoUrls[0];
              if (urlObj && urlObj.video_url) {
                if (BtnInner.length > 0) {
                  BtnInner[0].innerHTML = urlObj.type_name;
                }
                this.activatedClarityType = urlObj.type;
                this.player.src(urlObj.video_url);
                this.player.load();
              }
            }
          }
        },
        'videoPlayer',
        200
      );
    },
    // 更新播放器控件显示/隐藏
    updatePlayerControls() {
      if (!this.player) return;

      const hasValidUrls = this.hasValidVideoUrls;

      if (hasValidUrls) {
        // 如果有有效的视频URL，显示控件
        this.player.controls(true);
        // 显示播放控件栏
        if (this.player.controlBar) {
          this.player.controlBar.show();
          // 同时显示播放按钮
          if (this.player.controlBar.playToggle) {
            this.player.controlBar.playToggle.show();
          }
        }
      } else {
        // 如果没有有效的视频URL，隐藏控件
        this.player.controls(false);
        // 隐藏播放控件栏
        if (this.player.controlBar) {
          this.player.controlBar.hide();
          // 同时隐藏播放按钮
          if (this.player.controlBar.playToggle) {
            this.player.controlBar.playToggle.hide();
          }
        }
      }
    },
    hideClarityMenu(e) {
      // if(this.viplock) return
      if (!e.target.classList.contains('clarity_menu-flag')) {
        this.showClarityMenu = false;
      }

      const targetParent = e.target.parentNode;
      if (targetParent && targetParent.blur) {
        targetParent.blur();
      }
    },
    collectFn() {
      this.$emit('clickCollect', this.isCollection);
    },
    // 播放
    play() {
      this.player.play();
    },
    // 暂停
    pause() {
      this.player.pause();
    },
    //
    // 切换小节
    setChapter() {
      if (Array.isArray(this.datas) && this.datas[this.chapterIndex]) {
        this.video = this.datas[this.chapterIndex];
        this.updateVideo();
      }
    },
    // 显示视频结束画面
    showPlayEndTips() {
      this.showEndTips = true;
    },
    hidePlayEndTips() {
      this.showEndTips = false;
      this.readyCountdown = 0;
    },
    readyPlayNext() {
      if (!Array.isArray(this.datas) || (Array.isArray(this.datas) && this.chapterIndex >= this.datas.length - 1)) return;
      this.showPlayEndTips();
      this.readyCountdown = DEFAULT_COUNTDOWN_NUMBER;
      this.startReadyCountdown();
      if (this.chapterIndex < this.datas.length - 1) {
        this.chapterIndex += 1;
      } else {
        this.chapterIndex = this.datas.length - 1;
      }
      this.setChapter();
    },
    jumpReady() {
      this.hidePlayEndTips();
      this.play();
      this.$emit('playNext', this.video, this.chapterIndex);
    },
    cancelAutoPlay() {
      this.stopReadyCountdown();
      this.hidePlayEndTips();
    },
    startReadyCountdown() {
      if (this.readyCountdownTimer) {
        clearTimeout(this.readyCountdownTimer);
      }
      this.readyCountdownTimer = setTimeout(() => {
        this.readyCountdownTimer = null;
        this.readyCountdown -= 1;
        if (this.readyCountdown > 0) {
          this.startReadyCountdown();
        } else {
          this.jumpReady();
        }
      }, 1000);
    },
    stopReadyCountdown() {
      clearTimeout(this.readyCountdownTimer);
      this.readyCountdownTimer = null;
    },
  },

};
</script>

<style lang="scss" scoped>
.video-player-base {
  width: 100%;
  position: relative;

  .video-bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    max-width: 100%;
    overflow: hidden;

    &-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      vertical-align: bottom;
      opacity: 0.8;
      filter: blur(5px);
    }

    &-shadow {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      background-color: $A3;
      box-shadow: 0 0 10px 2px $C3 inset;
    }
  }

  .video-player-content {
    padding: 40px 0;
    display: flex;
    align-items: stretch;
    position: relative;

    .vip_lockinfo {
      width: 100%;
      position: relative;

      .viplock_div {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .viplock_icon {
        width: 96px;
        height: 56px;
      }

      .viplock_btn {
        width: 100px;
        height: 35px;
        background: #d1251b;
        color: #fff;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 13px;
        cursor: pointer;
      }
    }

    .video-player-bl {
      width: 72%;
      max-width: 827px;
      box-sizing: border-box;

      .video-wrap {
        width: 100%;
        padding-bottom: 56.25%;
        position: relative;

        .video-player {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 1;
          width: 100%;
          height: 100%;
          font-size: 10px;

          .vjs-tech,
          ::v-deep.vjs-button {
            outline: none;
          }

          ::v-deep.vjs-slider-vertical .vjs-volume-level:before {
            left: -0.5em;
          }

          ::v-deep.vjs-big-play-button {
            height: 60px;
            width: 60px;
            padding: 0;
            margin: 0;
            border-radius: 50%;
            border: none;
            line-height: 60px;
            font-size: 37px;
            background-color: $A4;
            cursor: pointer;
            outline: none;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }

          ::v-deep.vjs-icon-placeholder {
            color: $A3;
          }

          ::v-deep.vjs-control-bar .vjs-icon-placeholder {
            color: $C1;
          }

          ::v-deep.vjs-play-progress:before {
            top: -0.43em;
          }
        }

        .vjs-menu-item,
        ::v-deep.clarity_menu-flag {
          cursor: pointer;
        }

        .clarity_menu {
          position: absolute;
          z-index: 99;
          right: 35px;
          bottom: 3em;
          font-size: 10px;
          padding: 2px;
          width: 120px;
          color: $C1;

          .vjs-menu-content {
            background-color: rgba(43, 51, 63, 0.7);
            width: 100%;
            max-height: 15em;
          }
        }

        .volume_toast {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: rgba(255, 255, 255, 0.8);
          border-radius: 8px;
          padding: 10px 15px;
          z-index: 99;
          font-size: 36px;

          .iconfont {
            font-size: 30px;
          }

          .volume_value {
            font-weight: bold;
            margin-left: 10px;

            .volume_value-unit {
              font-size: 16px;
            }
          }
        }

        .ended-tips-wrap {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 100;
          background: $A3;
          color: $C1;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;

          .title {
            font-family: HYXinRenWenSongW;
            font-size: 16px;
            margin-bottom: 40px;
          }

          .ready-countdown {
            font-weight: bolder;
            font-size: 50px;
            text-align: center;
          }

          .subtitle {
            font-size: 14px;
            letter-spacing: 2px;
            margin: 30px 0;
          }

          .actions-bl {
            .btn {
              width: 98px;
              height: 40px;
              line-height: 40px;
              border: 1px solid $C2;
              text-align: center;
              cursor: pointer;
              font-family: HYXinRenWenSongW;
              display: inline-block;
            }

            .jump_btn {
              background: $C2;
              color: $C1;
              margin-right: 20px;
            }

            .cancel_btn {
              background: transparent;
              border-color: $C1;
              color: $C1;
            }
          }
        }
      }
    }

    .right-area {
      display: inline-flex;
      flex-direction: column;
      width: 28%;
      background: $C1;
      box-shadow: 0 0 26px 0 rgba(0, 0, 0, 0.2);
      padding: 40px 0 20px;
      box-sizing: border-box;
    }

    .speaker-info-bl {
      display: block;
      padding: 0 24px;
    }

    .video_intro {
      font-size: 12px;
      line-height: 18px;
      text-align: justify;
      color: $C4;
      overflow: hidden;
      padding: 0 20px;
      margin-top: 50px;
    }

    .speaker-info-wrap {
      box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);

      .speaker-info {
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        box-sizing: border-box;
        padding-bottom: 20px;
        width: 210px;
        max-width: 100%;
        margin: auto;
        border: none;

        .speaker_avatar {
          width: 56px;
          height: 56px;
          min-height: 56px;
          border-radius: 50%;
          overflow: hidden;
          margin: -28px 0 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
        }

        .speaker_name {
          margin-bottom: 8px;
          font-size: 15px;
          line-height: 15px;
          color: $C6;
        }

        .speaker_intro {
          font-size: 13px;
          color: $C4;
          line-height: 13px;
          margin-bottom: 8px;
          padding: 0 5px;
        }

        .speaker_rank {
          font-size: 13px;
          line-height: 13px;
          color: #bdbdbd;
        }
      }

      .actions-bl {
        display: flex;
        border-top: 1px solid #eee;

        .collectio_btn,
        .gift_btn {
          flex: 2;
          height: 36px;
          color: $C3;
          font-size: 14px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          &-icon {
            width: 15px;
            height: 15px;
            margin-right: 10px;
            vertical-align: middle;
          }
        }

        .collectio_btn {
          border-right: 1px solid #eee;

          &.active {
            color: $C13;
          }
        }
      }
    }
  }

  // 禁止右键
  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }
}
</style>
